import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../config/config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DieuHanhXulYService {

    constructor(
        private http: Http
    ) { }
    DanhSachYeuCau(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSach_YeuCauChuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachThietBiCoQuan(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSach_ThietBiCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCoQuanDonViQuyTrinh(YC){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSach_CoQuanDonViQuyTrinh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }    
    DanhSachNhanVienNhanChiDao(YC){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data =YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSach_NhanVienNhanChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachSanPhamThietbiLienQuan(IdYeuCau){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data ={IdYeuCau:IdYeuCau};
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSachSanPhamThietBiLienQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachNoiDungChiDao(YC){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data =YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSachNoiDungChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachTapTinYeuCau(IdYeuCau){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data ={IdYeuCau:IdYeuCau};
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSachTapTinYeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachTapTinXuLy(IdXuLy){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data ={IdXuLy:IdXuLy};
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DanhSachTapTinYeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Tao_ChiDao(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/uploadFileChiDao', formData, { headers: headers }).map(resp => resp.json());
    }    
    Tao_PhanHoiChidao(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/TaoPhanHoiChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Huy_PhanHoiChidao(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/HuyPhanHoiChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DownloadFile(filename, forder) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DieuHanhXuLy/DownloadFile?filename=' + filename+'&forder='+forder, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
    Huy_Chidao(YC) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/HuyChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    canhBaoChidao(YC){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YC;
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/canhBaoChiDao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DownloadFileChiDao(filename){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            FileName:filename
        }
        return this.http.post(Config.apiUrl + 'DieuHanhXuLy/DownloadFileChiDao',JSON.stringify(data), { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp =>
                resp.arrayBuffer());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/dieu-hanh/dieu-hanh.service.ts